/*
  <card-title-clamp> — clamps a product card title to N lines and shows a toggle
  when the title is actually truncated. Clicking the toggle expands the full
  title in place; it does not navigate to the product.
*/
(function () {
  if (customElements.get('card-title-clamp')) return;

  class CardTitleClamp extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.card-title-clamp__text');
      this.toggle = this.querySelector('.card-title-clamp__toggle');
      if (!this.text || !this.toggle) return;

      this.moreLabel = this.toggle.dataset.more || '\u2026';
      this.lessLabel = this.toggle.dataset.less || 'Show less';

      this.checkOverflow();

      this.toggle.addEventListener('click', (event) => {
        // The whole card is a link. Don't let the click bubble into navigation.
        event.preventDefault();
        event.stopPropagation();

        const expanded = this.classList.toggle('is-expanded');
        this.toggle.textContent = expanded ? this.lessLabel : this.moreLabel;
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          if (!this.classList.contains('is-expanded')) this.checkOverflow();
        });
        this.observer.observe(this.text);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    checkOverflow() {
      const overflowing = this.text.scrollHeight > this.text.clientHeight + 1;
      this.toggle.hidden = !overflowing;
    }
  }

  customElements.define('card-title-clamp', CardTitleClamp);
})();
